<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="showDialog"
    class="list-dialog"
    width="640px"
    :title="editing ? '修改推荐理由' : '请输入推荐理由'"
    @close="closeDialog('ruleForm')"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      class="reason-form"
      label-width="130px"
    >
      <el-form-item label="推荐理由：" prop="reason">
        <el-input
          type="textarea"
          class="input"
          v-model="ruleForm.reason"
          maxlength="200"
          show-word-limit
          placeholder="请输入推荐理由，不得少于10个字"
          resize="none"
          :rows="5"
        />
      </el-form-item>
      <el-form-item>
        <div class="flex-end">
          <el-button class="gray-button" @click="closeDialog('ruleForm')">取消</el-button>
          <el-button type="primary" @click="validateForm('ruleForm')">确认</el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: 'RecommendDialog',
  components: {},
  props: {
    showDialog: Boolean,
    book: Object,
    editing: Boolean,
  },
  data() {
    return {
      ruleForm: {},
      rules: {
        reason: [{ required: true, validator: this.validateReason, trigger: 'blur' }],
      },
    }
  },
  methods: {
    closeDialog() {
      this.$refs.ruleForm.resetFields()
      this.$emit('close')
    },
    async submitForm() {
      const book = this.book
      const recommendId = this.lodash.get(this.book, 'likeinfo.userdatalikeid', '')
      const body = {
        id: recommendId, // 有值是修改，没有值是新增
        dataId: book.id, // "资料id，整数",
        dbid: book.dbid, // "dbid",
        dataRuid: book.ruid, // "资料ruid",
        reason: this.ruleForm.reason, // "推荐理由"
      }
      const res = await this.$http.post('/api/v1/userdatalike/save', body)
      if (res.cxajaxrc !== 0) return false
      this.$message.success('推荐成功')
      this.$emit('finishRecommend')
      this.$bus.$emit('getBookList', 'list')
      this.closeDialog('ruleForm')
    },
    validateForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitForm()
        } else {
          return false
        }
      })
    },
    validateReason(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入推荐理由'))
      } else if (value.length < 10) {
        return callback(new Error('理由不得少于10字'))
      } else {
        callback()
      }
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
.flex-end {
  display: flex;
  justify-content: flex-end;
}
.gray-button {
  background-color: #f0f0f0;
  border-color: #f0f0f0;
  color: #666;
}
.list-dialog /deep/ .el-dialog {
  .el-dialog__title {
    font-size: 18px;
  }
  .el-dialog__close {
    font-size: 20px;
    &:hover {
      color: #fff;
    }
  }
  .el-form-item__label {
    font-size: 16px;
    color: #333;
  }
  .el-input__inner,
  .el-textarea__inner,
  .el-input__count {
    border-radius: 0;
    font-size: 16px;
  }
  .el-button {
    font-size: 16px;
    padding: 10px 20px;
  }
  .el-button--plain {
    background-color: #f0f0f0;
    color: #666;
  }
}
</style>
